<template>
  <div class="loyalty-tracker-section">
    <LoyaltyTracker
      format-values
      class="medium-margin-right-s"
      size="medium"
      :value="currentPoints"
      :tier="tierName?.toLowerCase() || LOYALTY.defaultTrackerTierName"
      :max="pointsThresholdForAward || LOYALTY.defaultMaxPointsThreshold"
    />
    <p v-if="!tierName" class="rewards medium-margin-top-xs">
      {{ LOYALTY.rewards }}
    </p>
  </div>
</template>
<script setup>
import LoyaltyTracker from '@atomic-ui/loyaltyTracker/LoyaltyTracker';
import useLoyalty from '@/composables/useLoyalty';
import { LOYALTY } from 'config';

const { currentPoints, pointsThresholdForAward, tierName } = useLoyalty();
</script>
<style lang="scss" scoped>
.loyalty-tracker-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  @include breakpoint(small only) {
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;
  }
}
</style>
